(function () {
  function initProductTabs(root) {
    if (root.dataset.tabsReady === 'true') return;
    root.dataset.tabsReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (tabs.length < 2) return;

    function select(tab, focusTab) {
      tabs.forEach(function (item) {
        var isActive = item === tab;
        var panel = document.getElementById(item.getAttribute('aria-controls'));

        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;

        if (!panel) return;
        panel.hidden = !isActive;
        panel.classList.remove('is-entering');
        if (isActive) {
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        }
      });

      tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (focusTab) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        select(tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        select(next, true);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.product-tabs').forEach(initProductTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after the theme editor or a section render swaps the markup.
  document.addEventListener('shopify:section:load', initAll);
})();
